import client from '../../client'

const login = params => {
  return client.post(`oauth/login`, params);
}

export {
  login
}



// WEBPACK FOOTER //
// ./src/store/api/auth.js